import React, { ReactNode } from 'react'
import { Button } from 'antd'
import RightOutlined from '@ant-design/icons/RightOutlined'
import LeftOutlined from '@ant-design/icons/LeftOutlined'
//styles
import styled, { css } from 'styled-components'
import { dimens } from '../shared-constants/dimens.tsx'
import { fontsWeight } from '../shared-constants/fonts'
import { colors } from '../shared-constants/colors.tsx'
import { SizeType } from 'antd/es/config-provider/SizeContext'
import { buttonTypes } from '../shared-constants/buttonTypes.tsx'

interface IProps {
  onClick: React.MouseEventHandler<HTMLButtonElement>
  icon: any
  iconColor: string
  shape: string
  children: ReactNode
  width: string
  height: string
  styletype: string
  onMouseDown: React.MouseEventHandler<HTMLButtonElement>
  loading: boolean
  disabled: boolean
  className: any
  justify: string
  dataCy: any
  img: any
  size: SizeType
  display: string
  margin: string
  customColor?: string
  type?: string
  htmlType?: string
}
//اگر خواستید مربع باشد، فقط عرض و ارتفاع را مشخص کنید و بین آن هر آیکنی می‌خواهید قرار دهید.
//اگر به دایره یا بیضی نیاز داشتید از شیپ استفاده کنید.
const CustomButton = (props: Partial<IProps>) => {
  const {
    className,
    onClick,
    onMouseDown,
    type = 'primary',
    width,
    height,
    styletype,
    loading,
    disabled,
    img,
    size,
    customColor,
    justify = 'center',
    display = 'flex',
    htmlType,
    icon,
    iconColor,
    children,
    shape,
    margin,
  } = props
  return (
    <ButtonContainer
      className={shape ? 'btn-shape' : className}
      type={type}
      onClick={onClick}
      onMouseDown={onMouseDown}
      width={width}
      height={height}
      styletype={styletype}
      loading={loading}
      disabled={disabled}
      icon={img}
      size={size}
      margin={margin}
      shape={shape}
      customColor={customColor}
      display={display}
      justify={justify}
      htmlType={htmlType}
    >
      {icon === 'back' && <BackIcon iconColor={iconColor} />}
      {children}

      {icon === 'go' && <GoIcon iconColor={iconColor} />}
    </ButtonContainer>
  )
}

export default CustomButton
interface IStyledProps {
  width: string
  height: string
  styletype: string
  customColor: string
  justify: string
  display: string
  margin: string
}
const ButtonContainer = styled(Button)<IStyledProps>`
  position: relative;
  display: ${(props) => props.display};
  align-items: center;
  justify-content: ${(props) => props.justify};
  border-radius: ${(props) => (props.shape ? '' : dimens.BORDER_RADIUS_4)};
  padding: ${(props) => (props.shape ? '' : dimens.SPACING_M)};
  width: ${(props) => props.width};
  height: ${(props) => props.height};
  font-weight: ${fontsWeight.MEDIUM};
  box-shadow: none;
  text-shadow: none !important;
  img {
    margin-inline-end: ${(props) => (props.margin ? props.margin : 0)};
  }
  &::after,
  &::before {
    box-shadow: none !important;
  }

  &.ant-btn-link {
    color: ${(props) => props.customColor} !important;
  }

  ${(props) =>
    props.styletype === buttonTypes.CUSTOM_FILL &&
    css`
      background-color: ${props.customColor} !important;
      color: ${colors.WHITE} !important;
      border: none !important;
      &:hover {
        background-color: ${props.customColor}+ '200' !important;
        color: ${colors.WHITE} !important;
      }
      &:active {
        background-color: ${props.customColor}+ '100' !important;
      }
      &:disabled {
        background-color: ${props.customColor}+ '50' !important;
        color: ${colors.WHITE};
      }
    `}

  ${(props) =>
    props.styletype === buttonTypes.CUSTOM_OUTLINE &&
    css`
      background-color: transparent !important;
      color: ${props.customColor} !important;
      border: 1px solid ${props.customColor} !important;
      &:hover {
        background-color: transparent !important;
        color: ${props.customColor} !important;
      }
      &:active {
        background-color: transparent !important;
      }
      &:disabled {
        color: ${colors.disableText} !important;
        border-color: ${colors.stroke2} !important;
      }
    `}

    ${(props) =>
    props.styletype === buttonTypes.PRIMARY_FILL &&
    css`
      background-color: ${colors.primaryBrandBg} !important;
      color: ${colors.onCriticalText} !important;
      border: none !important;
      &:hover {
        background-color: ${colors.primaryBrandBgHover} !important;
        color: ${colors.onCriticalText} !important;
      }
      &:active {
        background-color: ${colors.primaryBrandBgPress} !important;
      }
      &:disabled {
        background-color: ${colors.disableBg} !important;
        color: ${colors.onCriticalText};
      }
    `}

    ${(props) =>
    props.styletype === buttonTypes.PRIMARY_OUTLINE &&
    css`
      background-color: transparent !important;
      color: ${colors.primaryBrandText} !important;
      border: 1px solid ${colors.primaryBrandStroke} !important;
      &:hover {
        color: ${colors.primaryBrandTextHover} !important;
        border-color: ${colors.primaryBrandStrokeHover} !important;
      }
      &:active {
        color: ${colors.primaryBrandTextPress} !important;
        border-color: ${colors.primaryBrandStrokePress} !important;
      }
      &:disabled {
        color: ${colors.disableText} !important;
        border-color: ${colors.stroke2} !important;
      }
    `}

    ${(props) =>
    props.styletype === buttonTypes.ERROR_FILL &&
    css`
      background-color: ${colors.criticalBg} !important;
      color: ${colors.onCriticalText} !important;
      border: none !important;
      &:hover {
        background-color: ${colors.criticalBgHover} !important;
      }
      &:active {
        background-color: ${colors.criticalBgPress} !important;
      }
      &:disabled {
        background-color: ${colors.disableBg} !important;
      }
    `}

    ${(props) =>
    props.styletype === buttonTypes.ERROR_OUTLINE &&
    css`
      background-color: transparent !important;
      border: 1px solid ${colors.criticalStroke} !important;
      color: ${colors.criticalText} !important;
      &:hover {
        color: ${colors.criticalTextHover} !important;
        border-color: ${colors.criticalStroke3} !important;
      }
      &:active {
        color: ${colors.criticalTextPress} !important;
        border-color: ${colors.criticalStroke4} !important;
      }
      &:disabled {
        color: ${colors.disableText} !important;
        border-color: ${colors.stroke2} !important;
      }
    `}
    ${(props) =>
    props.styletype === buttonTypes.NO_STYLE &&
    css`
      background-color: transparent !important;
      border: 0 !important;
      color: ${colors.text1} !important;
    `}
`

const BackIcon = styled(RightOutlined)<any>`
  position: absolute !important;
  right: 0.75rem;
  color: ${(props) =>
    props.iconColor ? colors.primaryBrandText : props.iconColor};
`

const GoIcon = styled(LeftOutlined)<any>`
  position: absolute !important;
  left: 0.75rem;
  color: ${(props) => props.iconColor};
`
